<template>
  <el-dialog
    append-to-body
    width="1000px"
    title="申请发放"
    top="5vh"
    :visible.sync="visible"
    @close="close"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <div class="filter__wrap">
      <el-form ref="elFormDom" inline :model="table.params" :size="subUnitSize">
        <el-form-item label="用工单位" prop="company_id">
          <el-select
            v-model="table.params.company_id"
            placeholder="请选择"
            filterable
          >
            <el-option
              v-for="item in companyOpt"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="年份筛选" prop="year">
          <el-date-picker
            v-model="table.params.year"
            type="year"
            placeholder="选择年"
            format="yyyy年"
            value-format="yyyy"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="月份筛选" prop="month">
          <el-date-picker
            v-model="table.params.month"
            type="month"
            placeholder="选择月"
            format="MM月"
            value-format="MM"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item
          v-if="this.icId == 0"
          label="开票单位"
          prop="invoice_company_id"
        >
          <el-select
            v-model="table.params.invoice_company_id"
            placeholder="请选择"
            clearable
            filterable
            @change="getTable"
          >
            <el-option
              v-for="item in invoiceCompanyOpt"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="工资发放日期" prop="settlement_day">
          <el-select
            v-model="table.params.settlement_day"
            placeholder="请选择"
            clearable
            filterable
            @change="getTable"
          >
            <el-option
              v-for="item in settlement_day_options"
              :key="item"
              :label="item + '号'"
              :value="item"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否垫付" prop="prepayment_type">
          <el-select
            v-model="table.params.prepayment_type"
            placeholder="请选择"
            clearable
            filterable
            @change="getTable"
          >
            <el-option label="需要垫付" :value="1"></el-option>
            <el-option label="回款后发" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态" prop="received_status">
          <el-select
            v-model="table.params.received_status"
            placeholder="请选择"
            filterable
            clearable
          >
            <el-option label="全部回款" :value="1"></el-option>
            <el-option label="部分回款" :value="2"></el-option>
            <el-option label="未回款" :value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="发放日期"
          prop="issue_time"
          v-if="table.params.status == 5"
        >
          <el-date-picker
            v-model="table.params.issue_time"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            format="yyyy 年 MM 月 dd 日"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch">查询 </el-button>
          <el-button @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-table
      style="margin-top: 10px"
      class="m-b-10"
      border
      row-key="id"
      ref="tableRef"
      :data="table.data"
      height="400"
      @selection-change="handleSelectionChange"
      v-loading="loading"
    >
      <el-table-column
        type="selection"
        width="55"
        fixed
        align="center"
        :selectable="isCanSelect"
        reserve-selection
      >
      </el-table-column>
      <el-table-column label="ID" prop="id" align="center" width="80" fixed>
      </el-table-column>
      <el-table-column
        label="工资月份"
        prop="year"
        min-width="100"
        align="center"
      >
        <template slot-scope="{ row }">
          <span>{{ row.year }}-{{ row.month }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="用工单位"
        prop="company_name"
        show-overflow-tooltip
        min-width="150"
        align="center"
      >
      </el-table-column>
      <el-table-column
        label="开票单位"
        prop="invoice_company_id"
        show-overflow-tooltip
        min-width="150"
        align="center"
      >
        <template slot-scope="{ row }">
          {{ row.invoice.name }}
        </template>
      </el-table-column>
      <el-table-column
        label="生成时间"
        prop="created_at"
        show-overflow-tooltip
        min-width="150"
        align="center"
      >
      </el-table-column>
      <el-table-column
        label="在职总数/人"
        prop="total_employees"
        show-overflow-tooltip
        min-width="120"
        align="center"
      >
      </el-table-column>
      <el-table-column
        label="开票金额/元"
        prop="total_invoice"
        show-overflow-tooltip
        min-width="120"
        align="center"
      >
      </el-table-column>
      <el-table-column
        label="应发工资/元"
        prop="total_money"
        show-overflow-tooltip
        min-width="120"
        align="center"
      >
      </el-table-column>
      <el-table-column
        label="实发工资/元"
        prop="total_salary"
        show-overflow-tooltip
        min-width="120"
        align="center"
      >
      </el-table-column>
      <el-table-column
        label="定稿时间"
        prop="confirm_at"
        show-overflow-tooltip
        min-width="120"
        align="center"
      >
      </el-table-column>
      <el-table-column
        label="工资发放日期"
        prop="settlement_day"
        show-overflow-tooltip
        min-width="120"
        align="center"
      >
      </el-table-column>
      <el-table-column
        label="是否垫付"
        prop="prepayment_type"
        show-overflow-tooltip
        min-width="80"
        align="center"
      >
        <template slot-scope="{ row }">
          {{ { 1: "需要垫付", 2: "回款后发" }[row.prepayment_type] }}
        </template>
      </el-table-column>
      <el-table-column
        label="回款状态"
        prop="received_status"
        show-overflow-tooltip
        min-width="100"
        align="center"
      >
        <template slot-scope="{ row }">
          <span v-if="row.received_status == 3 || row.received_status == 0"
            >未回款</span
          >
          <span v-if="row.received_status == 2"
            >部分回款￥{{ row.received_amount }}</span
          >
          <span v-if="row.received_status == 1">全部回款</span>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      :small="true"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.total"
      :page-size="page.count"
      :currentPage="page.page"
      @current-change="currentPageChange"
      @size-change="pageSizeChange"
    ></el-pagination>
    <div style="margin-top: 10px" v-if="multipleSelection.length">已选数据</div>
    <div style="margin-top: 10px">
      <el-tag
        v-for="tag in multipleSelection"
        :key="tag.id"
        closable
        style="margin-right: 10px"
        @close="closeTag(tag)"
      >
        {{ tag.year }}-{{ tag.month }}-{{ tag.company_name }}
      </el-tag>
    </div>
    <template #footer>
      <el-row type="flex" justify="center">
        <el-button @click="toggle(false)">取消</el-button>
        <el-button
          type="primary"
          @click="confirm"
          :disabled="applyPaymentLoading"
          :loading="applyPaymentLoading"
          >确定</el-button
        >
      </el-row>
    </template>
    <applyPaymentDialog
      ref="applyPaymentDialogRef"
      @refresh="successApply"
    ></applyPaymentDialog>
  </el-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import { getStorage } from "@/storage";
import applyPaymentDialog from "./applyPaymentDialog.vue";
export default {
  components: { applyPaymentDialog },
  computed: {
    ...mapGetters({
      companyOpt: "companyList", // 获取企业列表
      invoiceCompanyOpt: "invoiceCompany", // 获取开票单位列表
    }),
  },
  data() {
    return {
      applyPaymentLoading: false,
      multipleSelection: [],
      tableData: [],
      subUnitSize: this.$store.state.subUnitSize, // 获取组件 size属性
      visible: false,
      loading: false,
      icId: Number(getStorage("icId")), // 登录账号的身份id（0：总公司, 2:鹰潭分公司）
      info: {},
      table: {
        loading: false,
        params: {
          company_name: "",
          order_type: 1,
          status: 4,
          pay_status: "",
          received_status: "",
          year: "",
          month: "",
          create_year: "", // 生成年
          create_month: "", // 生成月
          invoice_company_id: "", // 开票单位
          settlement_day: "", // 工资发放日期
          prepayment_type: "",
          issue_time: [],
        },
        data: [],
        total: 0,
      },
      page: {
        page: 1,
        count: 20,
        total: 0,
      },
      settlement_day_options: [
        1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
        21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31,
      ],
    };
  },
  methods: {
    isCanSelect(row) {
      if(row.is_used == 1){
        return false
      }else {
        return true
      }
    },
    currentPageChange(val) {
      this.page.page = val;
      this.getTable();
    },
    pageSizeChange(val) {
      this.page.count = val;
      this.page.page = 1;
      this.getTable();
    },
    onSearch() {
      this.table.params.page = 1;
      this.table.data = [];
      this.getTable();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    successApply() {
      this.multipleSelection = []
      this.$refs.tableRef.clearSelection();
      this.getTable();
    },
    closeTag(tag) {
      this.$refs.tableRef.toggleRowSelection(tag, false);
      this.multipleSelection = this.multipleSelection.filter(
        (v) => v.id !== tag.id
      );
    },
    getTable() {
      let [issue_start = "", issue_end = ""] =
        this.table.params.issue_time || [];
      let params = {
        ...this.table.params,
        issue_end,
        issue_start,
        // ...this.info,
        page: this.page.page,
        count: this.page.count,
      };
      this.loading = true;
      this.$http
        .post("/admin/finance/list", params)
        .then((res) => {
          if (res.code === 1) {
            this.table.data = res.data.list;
            this.page.total = res.data.total;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    reset() {
      this.$refs.elFormDom.resetFields();
      this.table.params.page = 1;
      this.getTable();
    },
    close() {
      this.$refs.elFormDom.resetFields();
      this.multipleSelection = []
      this.$refs.tableRef.clearSelection();
      this.table.params.page = 1;
      this.toggle(false);
    },
    toggle(show) {
      this.visible = show;
      !show && this.reset();
    },
    getDetail(obj) {
      this.info = obj;
      this.getTable();
    },
    // 提交
    confirm() {
      let list = this.multipleSelection;
      if (list.length > 0) {
        let list2 = list.map((item) => item.invoice_company_id);
        let isSame = list2.every((item) => item === list2[0]);
        if (!isSame) {
          this.$message.error("所选数据不属于同一开票单位，请重新选择！");
          return;
        } else {
          let params = {
            settlement_ids: list && list.map((item) => item.id).join(","),
          };
          this.applyPaymentLoading = true;
          this.$http
            .post("/admin/finance/showApplyPayment", params)
            .then((res) => {
              if (res.code == 1) {
                let dom = this.$refs.applyPaymentDialogRef;
                dom.toggle(true);
                dom.getDetail(list);
                dom = null;
              }
            })
            .finally(() => {
              this.applyPaymentLoading = false;
            });
        }
      } else {
        this.$message.error("请选择数据！");
      }
    },
  },
};
</script>

<style scoped lang="scss">
// .el-table {
//   &::v-deep {
//     .el-table__body-wrapper::-webkit-scrollbar {
//       width:2px;
//     }
//     .el-table__body-wrapper::-webkit-scrollbar-thumb {
//       background: #8d8d8d;
//       border-radius: 3px;
//     }
//   }
// }
::v-deep .el-form-item {
  margin-bottom: 10px !important;
}
</style>
